import { request } from "@/elearningservice/service/request.js";

//添加免費商品
const addFreeOrder = async (data) => {
	const res = await new request().connectNsuv().post("", { fun: "order", op: "addFreeOrder" }, data);
	return res;
};

export { addFreeOrder };
